<template>
  <div :class="dynamicClasses">
    <div class="flex justify-evenly relative">
      <input id="sunday" v-model="content" type="checkbox" class="day-token" value="0" />
      <label for="sunday" class="day-token-label mr-8">
        <DayTokenS />
        <span aria-hidden="true" class="day-token-marker">Sun</span>
        <span class="sr-only">Sunday</span>
      </label>

      <input id="monday" v-model="content" type="checkbox" class="day-token" value="1" />
      <label for="monday" class="day-token-label mr-8">
        <DayTokenM />
        <span aria-hidden="true" class="day-token-marker">Mon</span>
        <span class="sr-only">Monday</span>
      </label>

      <input id="tuesday" v-model="content" type="checkbox" class="day-token" value="2" />
      <label for="tuesday" class="day-token-label mr-8">
        <DayTokenT />
        <span aria-hidden="true" class="day-token-marker">Tue</span>
        <span class="sr-only">Tuesday</span>
      </label>

      <input id="wednesday" v-model="content" type="checkbox" class="day-token" value="3" />
      <label for="wednesday" class="day-token-label mr-8">
        <DayTokenW />
        <span aria-hidden="true" class="day-token-marker">Wed</span>
        <span class="sr-only">Wednesday</span>
      </label>

      <input id="thursday" v-model="content" type="checkbox" class="day-token" value="4" />
      <label for="thursday" class="day-token-label mr-8">
        <DayTokenT />
        <span aria-hidden="true" class="day-token-marker">Thu</span>
        <span class="sr-only">Thursday</span>
      </label>

      <input id="friday" v-model="content" type="checkbox" class="day-token" value="5" />
      <label for="friday" class="day-token-label mr-8">
        <DayTokenF />
        <span aria-hidden="true" class="day-token-marker">Fri</span>
        <span class="sr-only">Friday</span>
      </label>

      <input id="saturday" v-model="content" type="checkbox" class="day-token" value="6" />
      <label for="saturday" class="day-token-label">
        <DayTokenS />
        <span aria-hidden="true" class="day-token-marker">Sat</span>
        <span class="sr-only">Saturday</span>
      </label>
    </div>
    <HelperText v-if="helperText" :text="helperText" :status="status" />
  </div>
</template>

<script lang="ts">
import DayTokenS from '../../icons/DayTokenS.vue';
import DayTokenM from '../../icons/DayTokenM.vue';
import DayTokenT from '../../icons/DayTokenT.vue';
import DayTokenW from '../../icons/DayTokenW.vue';
import DayTokenF from '../../icons/DayTokenF.vue';
import helperStatus from '../../helpers/status';
import HelperText from '../helper_text/HelperText.vue';

export default {
  name: 'DayTokens',
  components: {
    DayTokenS,
    DayTokenM,
    DayTokenT,
    DayTokenW,
    DayTokenF,
    HelperText,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
      required: false,
    },
    status: {
      type: Number as () => helperStatus,
      default: helperStatus.Neutral,
    },
    helperText: {
      type: String,
    },
  },
  data(): any {
    return {
      content: this.value,
    };
  },
  computed: {
    dynamicClasses(): String {
      if (this.hasError) {
        return 'daytokens-error';
      }
      return 'daytokens';
    },
    hasError(): Boolean {
      return this.status === helperStatus.Error;
    },
  },
  watch: {
    content(selectedDays: string[]) {
      this.$emit('input', selectedDays);
    },
  },
};
</script>

<style lang="scss" scoped>
.day-token {
  opacity: 0;
  position: absolute;
  width: 0;

  &:focus-visible + .day-token-label,
  &:hover + .day-token-label,
  &:checked + .day-token-label {
    color: theme('colors.primary.DEFAULT');
  }

  &:focus-visible + .day-token-label {
    border-radius: '4px';
    border: 2px dotted theme('colors.primary.DEFAULT');
  }

  &:checked + .day-token-label :deep(svg) {
    fill: theme('colors.primary.subdued');
  }

  &:checked + .day-token-label :deep(circle) {
    stroke-width: 2px;
  }
}

.day-token-label {
  color: theme('colors.grey.text.subdued');
  cursor: theme('cursor.pointer');
  padding: 0.25rem 0;
  text-align: center;
}

.day-token-marker {
  font-size: theme('fontSize.s');
}

.daytokens-helper {
  color: theme('colors.grey.text.subdued');
  font-family: theme('fontFamily.sans');
  font-size: theme('fontSize.xs');
  font-weight: theme('fontWeight.regular');
  margin-top: theme('spacing.4');
  letter-spacing: 0.4px;
}

.daytokens-error .daytokens-helper {
  color: theme('colors.critical.DEFAULT');
}
</style>
